import { marker } from '@jsverse/transloco-keys-manager/marker';

import { sharedI18nKeys } from '@vlaio/shared/i18n';

export const I18nKeys = {
	...sharedI18nKeys,
	PageTitles: {
		Offers: marker('page-titles.offers')
	},
	Products: {
		Loading: {
			Facets: marker('products.loading.facets'),
			Products: marker('products.loading.products')
		},
		Actions: {
			LoadMore: marker('products.actions.load-more'),
			Search: marker('products.actions.search'),
			Filter: marker('products.actions.filter'),
			ShowResults: marker('products.actions.show-results'),
			MoreFilters: marker('products.actions.more-filters'),
			LessFilters: marker('products.actions.less-filters'),
			ClearAll: marker('products.actions.clear-all'),
			Sort: marker('products.actions.sort')
		},
		Detail: {
			Via: marker('products.detail.via'),
			RecommendedBy: marker('products.detail.recommended-by'),
			Recommended: marker('products.detail.recommended')
		},
		Empty: marker('products.empty'),
		EmptyAfterFilteredSearch: marker('products.empty-after-filtered-search'),
		NoFilters: marker('products.no-filters'),
		Intro: marker('products.intro'),
		Error: marker('products.error'),
		Recommended: marker('products.recommended'),
		Recommendations: {
			Title: marker('products.recommendations.title'),
			Description: marker('products.recommendations.description'),
			Recommended: marker('products.recommendations.recommended')
		}
	}
};
